<template>
    <div>   <a-drawer
            :title='title'
            :visible="visible"
            v-bind="drawerConfig"
            :body-style="{ paddingBottom: '80px' }"
            @close="onClose"
    >
        <a-form-model ref="ruleForm" :model="form" :rules="rules" v-bind="layout">
          <a-form-model-item label="类型名称">{{form.name}}</a-form-model-item>
          <a-form-model-item label="所属板块">{{form.category}}</a-form-model-item>
          <a-form-model-item label="指令词">{{form.word}}</a-form-model-item>
            <a-form-model-item
                    ref="instruct"
                    label="指令内容"
                    prop="instruct"
                    :help="formErr.instruct"
                    :validateStatus='!formErr.instruct||formErr.name==""?"":"error"'
            >
                <a-input  type="textarea"
                          v-model="form.instruct"
                        @change="(e) => { formErr.instruct=''}"
                        @blur="(e) => {  form.instruct = e.target.value.trim();}"
                />

            </a-form-model-item>
            <a-form-model-item
                    ref="remark"
                    label="备注内容"
                    prop="remark"
                    :help="formErr.remark"
                    :validateStatus='!formErr.remark||formErr.remark==""?"":"error"'
            >
                <a-input type="textarea"
                         v-model="form.remark"
                        @change="(e) => { formErr.remark=''}"
                        @blur="(e) => {  form.remark = e.target.value.trim();}"
                />
            </a-form-model-item>
        </a-form-model>
        <div class="drawer-btn"  >

            <a-button type="primary" @click="onSubmit" :style="{ marginRight: '8px' }">
                确定
            </a-button>
            <a-button @click="onClose">
            取消
        </a-button>
        </div>
    </a-drawer></div>
</template>

<script>
    import {submitForm,drawerConfig,validator} from "../../../../utils/utils"
    import API from "../api";
    import moment from 'moment';
    export default {
        name: "newForm",
        // props: ["visible","title","editId"],
        props: {
            visible:{type: Boolean,},
            title:{type: String,},
            editId:{type: [String, Number],},

        },
        data() {
            return {
                seleList:[],
                drawerConfig ,
                dateFormat: 'YYYY-MM-DD HH:mm:ss',
                form: {
                  remark:"",
                  instruct:"",
                },
                formErr: {
                  remark:"",
                  instruct:"",
                },
                rules: {
                  // remark: [{required: true, message: "请输入备注内容",  },{validator:(rule, value, callback)=>{validator(rule, value, callback,this.formErr.remark)}  , trigger: "blur"  },],
                  instruct: [{required: true, message: "请输入指令内容",  }, {validator:(rule, value, callback)=>{validator(rule, value, callback,this.formErr.instruct)}  , trigger: "blur"  },],
                    },
                layout: {
                    labelCol: { span:4},
                    wrapperCol: { span:16},
                },
            };
        },
        watch:{
            visible:function(){
            },
            editId: function (a, b) {
                if (a != "") {
                    API.service.EDIT_DATA(a).then(res => {
                        let data=res.data.data
                        this.form = data
                        this.form.id=a
                    })
                } else {
                    this.form.id = ''

                }
            }
        },
        mounted(){
            // this.getFormData()
        },
        methods: {
            // getFormData(){
            //     API.service.ADD_DATA().then(res => {
            //         this.seleList={
            //             category:res.data.data.category,
            //             status:res.data.data.status,
            //         }
            //     })
            // },
            onClose() {
                this.$emit("changVisible", false);
                this.formErr={
                  remark:"",
                  instruct:"",
                }
                this.$refs.ruleForm.resetFields();
            },
            onSubmit() {
                let _this = this;
             //    let subData=JSON.parse(JSON.stringify(this.form))
             // alert(subData.release_time!=""&&subData.release_time!=null)
               this.$refs.ruleForm.validate(valid => {
                    if (valid) {
                        let url
                        let subData=JSON.parse(JSON.stringify(this.form))
                            url = API.service.SUBMIT_EDIT
                        submitForm(url, subData).then(res => {
                            if (res == true) {
                                this.onClose()
                            } else {
                                res.map((item, index) => {
                                    this.formErr[item.field] = item.msg
                                })
                            }
                        })
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
        },
    }
</script>

<style scoped>
.ant-input-number-input{width: 100%!important;}
.ant-input{margin-bottom: 20px}
.ant-form-item{margin-bottom: 0}
</style>
